var list = [];

export { default as generic } from "./generic.js";
list.push("generic");

export { default as hms } from "./hms.js";
list.push("hms");

export { default as bu } from "./bu.js";
list.push("bu");

export { default as mgh_em } from "./mgh_em.js";
list.push("mgh_em");

export { default as stanford } from "./stanford.js";
list.push("stanford");

export { default as uva_anes } from "./uva_anes.js";
list.push("uva_anes");

export { default as lah_rad } from "./lahey/lah_rad.js";
list.push("lah_rad");

export { default as lah_rad_chief } from "./lahey/lah_rad_chief.js";
list.push("lah_rad_chief");

export { default as ucla_data_summary_professor } from "./ucla/ucla_data_summary_professor.ts";
list.push("ucla_data_summary_professor");

export { default as ucla_data_summary } from "./ucla/ucla_data_summary.ts";
list.push("ucla_data_summary");

export { default as uva_med_annual_review } from "./uva_med/uva_med_annual_review.ts";
list.push("uva_med_annual_review");

export { default as stanford_em_afcs } from "./stanford_em/stanford_em.ts";
list.push("stanford_em_afcs");

export { default as demo_cc } from "./demo/demo_cc.ts";
list.push("demo_cc");

export { list };
